/** Schema v1 — short keys in events[] for smaller payloads. */
export const FE_TELEMETRY_SCHEMA_VERSION = 1;

export type FeEventKind = 'api' | 'pv' | 'pl' | 'clk' | 'tab' | 'act' | 'log';

export type FePageContext = {
  path: string;
  route: string;
  asn?: string;
  cls?: string;
};

export type FeApiEvent = {
  k: 'api';
  t: string;
  m: string;
  p: string;
  pt: string;
  s?: number;
  d: number;
  ok: boolean;
  rid?: string;
};

export type FePageViewEvent = {
  k: 'pv';
  t: string;
  path: string;
  route: string;
  ref?: string;
};

export type FePageLeaveEvent = {
  k: 'pl';
  t: string;
  path: string;
  route: string;
  dwell: number;
};

export type FeClickEvent = {
  k: 'clk';
  t: string;
  el: string;
  lb?: string;
  act?: string;
  tag?: string;
};

export type FeTabEvent = {
  k: 'tab';
  t: string;
  vis: 'visible' | 'hidden';
  hid?: boolean;
};

export type FeActionEvent = {
  k: 'act';
  t: string;
  name: string;
  asn?: string;
  cls?: string;
  meta?: Record<string, unknown>;
};

export type FeLogEvent = {
  k: 'log';
  t: string;
  lvl: 'info' | 'warn' | 'debug';
  msg: string;
  ctx?: Record<string, unknown>;
};

export type FeTelemetryEvent =
  | FeApiEvent
  | FePageViewEvent
  | FePageLeaveEvent
  | FeClickEvent
  | FeTabEvent
  | FeActionEvent
  | FeLogEvent;

export type FeTelemetryBatch = {
  v: number;
  sid: string;
  sentAt: string;
  ctx: FePageContext;
  events: FeTelemetryEvent[];
};
